import { Text } from '../Text/Text.es.js';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var Heading = styled(Text).withConfig({
  componentId: "sc-2igbz0-0"
})(["margin-top:0;margin-bottom:", ";"], spacing("md"));
Heading.displayName = "Heading";
Heading.defaultProps = {
  as: "h2",
  size: "md",
  contrast: "base",
  fontWeight: "bold"
};
export { Heading };